import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Server-rendered SEO tags (title/meta/canonical/JSON-LD) are injected for crawlers
// before this bundle loads (see /app/frontend/src/setupProxy.js). Strip them here,
// before React mounts, so react-helmet-async can manage a clean, single set of tags.
document.querySelectorAll("[data-ssr]").forEach((el) => el.remove());

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
